import { Controller } from "@hotwired/stimulus";

// Picking a car prefills the number of seats and the departure place of a
// transport offer with the car's defaults, unless they are filled in already.
export default class extends Controller {
  static targets = ["places", "departurePlace"];

  async change({target}) {
    const response = await fetch(`/cars/${encodeURIComponent(target.value)}.json`, {
      headers: {Accept: "application/json"},
      credentials: "same-origin",
    });
    if (!response.ok) return;
    const car = await response.json();
    if (this.placesTarget.value === "") this.placesTarget.value = car.default_places ?? "";
    if (this.departurePlaceTarget.value === "") {
      this.departurePlaceTarget.value = car.default_start_place ?? "";
    }
  }
}
